<template>
  <div class="myRegistration">
    <h3 class="containner-title">បុគ្គលដែលបានចូលរួមវគ្គបណ្តុះបណ្តាល</h3>
    <div class="p-3 bg-light shadow-sm bg-white rounded border">
      <div class="row mb-4 mt-4">
            <div class="col">
              <label class="fw-bold">{{$t("message.name")}}: </label> 
              {{trainingParticipnats.title}}
            </div>
            <div class="col">
              <label class="fw-bold">{{$t("message.register_type")}}: </label> 
              {{trainingParticipnats.apply_for==1 ? 'NEW' : trainingParticipnats.apply_for==2 ? 'CPE' : '--'}}
            </div>
           
      </div>
      <div class="row mb-4 mt-4">
         <div class="col">
            <label class="fw-bold">{{$t("message.business_type")}}: </label> 
            {{getBusinessType(trainingParticipnats.type)}}
          </div>
            <div class="col"><label class="fw-bold">{{$t("message.training_date")}}: </label> 
            {{trainingParticipnats.start_date}}-{{trainingParticipnats.end_date}}
          </div> 
      </div>
      <div class="row mb-4 mt-4">
        <div class="col">
          <label class="fw-bold">{{$t("message.examination_date")}}: </label> 
          {{trainingParticipnats.exam_date}}, Time: {{trainingParticipnats.start_time}} - {{trainingParticipnats.end_time}}
        </div> 
        <div class="col"><label class="fw-bold">{{$t("message.description")}}: </label> {{trainingParticipnats.description}}</div> 
      </div>
    </div>
    <div class="card-body border" style="background-color: #f1f1f1;">
      
      <form class="form" v-on:submit.prevent>
        
        <div class="row mb-4">
          <div class="col-12" style="text-align: right;margin-top: 5px;">
           
            <div class="btn-group" role="group">
              <router-link type="button" class="btn btn-danger" :to="{ name: 'adminTrainingGroup' }">
                <i class="fas fa-arrow-left"></i>
                {{$t("message.back")}}
              </router-link>
              <button class="btn btn-dark"><i class="fas fa-print"></i></button>
              <button class="btn btn-primary" @click="exportExcel"><i class="fas fa-file-excel"></i> {{$t("message.export")}}</button>
              <button class="btn btn-success" @click="saveLoadAllRegisters"><i class="fas fa-plus"></i> {{$t("message.automatic_join_training")}}</button>
              <!-- <button class="btn btn-primary m-1"><i class="fas fa-search"></i> Search</button> -->
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col">
            <label for="first-name" class="form-label">{{$t("message.last_name")}}</label>
            <input type="text" 
            class="form-control" 
            v-model="search.lastname"
            placeholder="Last name" 
            aria-label="Last name">
          </div>
          <div class="col">
            <label for="first-name" class="form-label">{{$t("message.first_name")}}</label>
            <input type="text" 
              class="form-control" 
              placeholder="First name" 
              v-model="search.firstname"
              aria-label="First name">
          </div>
          <div class="col">
            <label for="first-name" class="form-label">{{$t("message.phone")}}</label>
            <input type="text" 
            class="form-control" 
            v-model="search.phone"
            placeholder="Phone">
          </div>
          <div class="col">
            <label for="first-name" class="form-label">{{$t("message.gender")}}</label>
            <select
              class="form-select"
              placeholder="Gender"
              v-model="search.gender"
            >
              <option value="" selected>Choose...</option>
              <option value="1">{{$t("message.male")}}</option>
              <option value="2">{{$t("message.female")}}</option>
            </select>
          </div>
        </div>
      </form>
    </div>
    <div> 
      <div class="row">
        <div class="col-10">
          <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}: 
            <span class="text-primary">
              {{getTotal}} {{$t("message.neak")}}
            </span>
          </label> 
        </div>
        <div class="col-2 text-end">
          <button v-if="!swicthEdit" class="btn btn-primary me-3 mt-2" @click="changeSwichEdit"><i class="fas fa-solar-panel"></i> {{$t("message.enter_result")}}</button>
          <button v-if="swicthEdit" class="btn btn-danger me-3 mt-2" @click="saveResult"><i class="fas fa-save"></i> {{$t("message.save")}}</button>
        </div>
      </div>
      <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>{{$t("message.name")}}</th>
                <th>{{$t("message.gender")}}</th>
                <th>{{$t("message.dob")}}</th>
                <th>{{$t("message.marital_status")}}</th>
                <th>{{$t("message.phone")}}</th>
                <th>{{$t("message.nationality")}}</th>
                <th>{{$t("message.register_date")}}</th>
                <th>{{$t("message.score")}}</th>
                <th>{{$t("message.result")}}</th>
                <th>{{$t("message.expiration_date")}}</th>
                <th class="text-center">{{$t("message.action")}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in filterParticipate" :key="index">
                <th style="vertical-align: middle;width: 30px;">{{index+1}}</th>
                <td style="vertical-align: middle;">{{item.participant.lastname + ' ' + item.participant.firstname}}</td>
                <td style="vertical-align: middle;">{{item.participant.gender == 1 ? 'M' : 'F'}}</td>
                <td style="vertical-align: middle;">{{item.participant.dob}}</td>
                <td style="vertical-align: middle;">{{item.participant.marital_status == 1 ? 'នៅលីវ' : item.participant.marital_status == 2 ? 'បានរៀបការ' :''}}</td>
                <td style="vertical-align: middle;">{{item.participant.phone}}</td>
                <td style="vertical-align: middle;">{{item.participant.nationality_name}}</td>
                <td style="vertical-align: middle;">{{item.created_at}}</td>
                <td style="vertical-align: middle;" v-if="swicthEdit">
                  <input type="text" 
                      class="form-control" 
                      v-model="item.score"
                      placeholder="Score">
                </td>
                
                <td style="vertical-align: middle;" v-if="swicthEdit">
                  <select
                    class="form-select"
                    placeholder="Pass/Fail"
                    v-model="item.is_pass"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">Pass</option>
                    <option value="2">Fail</option>
                  </select>
                </td>
                <td style="vertical-align: middle;" v-if="swicthEdit">
                    <input
                      v-maska="'##/##/####'"
                      v-model="item.license_expiry_date"
                      class="form-control"
                      placeholder="Expiry date"
                      aria-label="Expiry date"
                    />
                </td>

                <td style="vertical-align: middle;" v-if="!swicthEdit">
                  {{item.score}}
                </td>
                <td style="vertical-align: middle;" v-if="!swicthEdit">
                  {{item.is_pass== 1 ? 'pass' : item.is_pass== 2 ? 'fail' : ''}}
                </td>
                <td style="vertical-align: middle;" v-if="!swicthEdit">
                  {{item.license_expiry_date}}
                </td>
                <td style="vertical-align: middle;" class="text-center">
                  <!-- <button class="btn btn-primary" 
                    data-bs-toggle="modal" 
                    data-bs-target="#staticBackdrop"
                    @click="showDetail(item)">
                    <i class="far fa-edit"></i>
                  </button> -->
                  <div class="btn-group" role="group">
                    <router-link class="btn btn-primary" :to="{ name: 'showParticipant' , params:{id:item.id}}"><i class="far fa-edit"></i></router-link>
                    <button class="btn btn-danger" @click="dropRegistersFromTrainingGroup(item)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
      </table>
    </div>
    <!-- Modal -->
    <div class="modal fade" 
        id="staticBackdrop" 
        data-bs-backdrop="static" 
        data-bs-keyboard="false" 
        tabindex="-1" 
        aria-labelledby="staticBackdropLabel" 
        aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollabl modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">{{selectShow.participant.lastname + ' ' + selectShow.participant.firstname}}</h5>
            <button type="button" class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"></button>
          </div>
          <div class="modal-body">
            ...
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Understood</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      search: {lastname: '', firstname: '', phone: '', gender: ''},
      swicthEdit: false,
      trainingParticipnats: {
        registration_participant:[]
      },
      selectShow: {
        participant:{lastname: '', firstname: ''}
      }
    };
  },
  computed: { 
    getTotal(){
      return typeof this.trainingParticipnats.registration_participant == 'undefined' 
      ? 0 : this.trainingParticipnats.registration_participant.length;
    },
    filterParticipate(){
      return this.trainingParticipnats.registration_participant.filter(v=>{
        let condition = true;
        if(this.search.lastname != ''){
          condition = condition && v.participant.lastname.indexOf(this.search.lastname) > -1;
        }
        if(this.search.firstname != ''){
          condition = condition && v.participant.firstname.indexOf(this.search.firstname) > -1;
        }
        if(this.search.phone != ''){
          condition = condition && v.participant.phone.indexOf(this.search.phone) > -1;
        }
        if(this.search.gender != ''){
          condition = condition && v.participant.gender == this.search.gender;
        }
        //console.log(v,this.search);
        return condition;
      });
        
    },
    getBusinessType(){
      return (t) =>{
        switch (t){
            case '1':
            case 1:
                return this.$t("message.stock_business");
            case '2':
            case 2:
                return this.$t("message.derivative_business");
            case '4':
            case 4:
                return this.$t("message.found");
            default:
                return t;
        }
      }
    }
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    async loadData(){
      let loader = this.showLoader();
      this.trainingParticipnats = {
        registration_participant:[]
      };
      const respone = await axios.get("training-group-participant/" + this.$route.params.id, {
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        this.trainingParticipnats = respone.data.data;
        console.log("this data:",respone.data);
      }
      loader.hide();
    },
    async saveLoadAllRegisters(){
      this.$swal
      .fire({
        title: "តើអ្នកចង់រក្សាទុកទិន្នន័យនេះមែនទេ?",
        showCancelButton: true,
        confirmButtonText: `យល់ព្រម`,
        cancelButtonText: `បោះបង់`
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          let loader = this.showLoader();
          this.trainingParticipnats = {
            registration_participant:[]
          };
          const respone = await axios.post("create-training-group-participant/" + this.$route.params.id, 
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.getAuthToken
            }
          });
          if (respone.status == 200) {
            this.trainingParticipnats = respone.data.data;
            //console.log("this data:",respone.data);
          }
          loader.hide();
        }
      });
    },
    async dropRegistersFromTrainingGroup(v){
      this.$swal
      .fire({
        title: "តើអ្នកចង់លុបទិន្នន័យនេះមែនទេ?",
        showCancelButton: true,
        confirmButtonText: `យល់ព្រម`,
        cancelButtonText: `បោះបង់`
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          let loader = this.showLoader();
          const respone = await axios.post("drop-training-group-participant/" + v.id, 
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.getAuthToken
            }
          });
          if (respone.status == 200) {
            let t = [...this.trainingParticipnats.registration_participant];
            this.trainingParticipnats.registration_participant = t.filter(s=>s.id!=v.id);
            //this.trainingParticipnats = respone.data.data;
            //console.log("this data:",respone.data);
          }
          loader.hide();
        }
      });
    },
    showDetail(v){
      this.selectShow = {...v};
    },
    async exportExcel(){
      this.$swal
        .fire({
          title: "តើអ្នកចង់ export excel មែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
              let loader = this.showLoader();
              const response = await axios.post("export-trainee-training-group/"+this.$route.params.id,{} ,{
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                },
                responseType: "blob"
              });
              const type = response.headers["content-type"];
              const blob = new Blob([response.data], {
                type: type,
                encoding: "UTF-8"
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "all-tranees.xlsx";
              link.click();
              loader.hide();
          }
        });
    },
    changeSwichEdit(){
      this.swicthEdit = !this.swicthEdit;
    },
    async saveResult(){
      this.$swal
      .fire({
        title: "តើអ្នកចង់រក្សាទុកទិន្នន័យនេះមែនទេ?",
        showCancelButton: true,
        confirmButtonText: `យល់ព្រម`,
        cancelButtonText: `បោះបង់`
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          let loader = this.showLoader();
          this.changeSwichEdit();
          const respone = await axios.post("save-result-registor", 
          {
            data:this.trainingParticipnats.registration_participant
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.getters.getAuthToken
            }
          });
          if (respone.status == 200) {
            this.loadData();
          }
          loader.hide();
        }
      });
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
  }, components: {}
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}
</style>
